import React from 'react';

import {useClientServerEffect} from 'coreHooks';
import useSSRStyle from 'coreHooks/useSSRStyle';

import {FirstModuleProvider} from './FirstModuleContext';
import {IPageProps} from './IPage';

const Page = (props: IPageProps) => {
	const {addStyle, deleteStyle} = useSSRStyle();
	const styleKey = `contentful-page-${props.sys?.id}`;

	useClientServerEffect(() => {
		if (props?.style) {
			addStyle(styleKey, `:root { ${props.style} }`);
		}

		return () => deleteStyle(styleKey);
	}, []);

	if (!props?.children && !props?.contentCollection?.items?.length) {
		return <></>;
	}

	const [firstModule, ...otherModules] = Array.isArray(props?.children) ? props.children : [props?.children];

	// This should remain in the Contentful context
	return (
		<>
			{props?.children ? (
				<>
					<FirstModuleProvider>{firstModule}</FirstModuleProvider>
					{otherModules}
				</>
			) : props?.contentCollection?.items[0]}
		</>
	);
};

export default Page;
